(() => {
  'use strict';
  fetch('/api/frontend-config', { credentials: 'omit' })
    .then((response) => response.ok ? response.json() : null)
    .then((config) => {
      if (!config?.umami || document.getElementById('umami-analytics')) return;
      const scriptURL = new URL(config.umami.scriptUrl, window.location.origin);
      if (scriptURL.protocol !== 'https:' || typeof config.umami.websiteId !== 'string' || !config.umami.websiteId.trim()) return;
      const script = document.createElement('script');
      script.id = 'umami-analytics';
      script.src = scriptURL.href;
      script.dataset.websiteId = config.umami.websiteId;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    })
    .catch(() => {});
})();
